// modules/dashboard/components/GraficoBarras.js
// Barras de UNA sola serie → un solo color (el de la estrategia). Antes cada
// barra tenía un color distinto, lo que hacía parecer que eran categorías
// con significado propio.
import { Bar } from "react-chartjs-2";
import { Chart as ChartJS, BarElement, CategoryScale, LinearScale, Tooltip } from "chart.js";
import { AZUL_INSTITUCIONAL, REJILLA, TEXTO_2, GRIS_OSCURO } from "../utils/colores";
ChartJS.register(BarElement, CategoryScale, LinearScale, Tooltip);
ChartJS.defaults.font.family = '"Segoe UI", system-ui, -apple-system, Roboto, sans-serif';
ChartJS.defaults.color = TEXTO_2;

function truncar(texto, max = 26) {
  const t = String(texto);
  return t.length > max ? t.slice(0, max - 2) + "…" : t;
}

export default function GraficoBarras({ datos, horizontal = true, alto, topN = null, color = AZUL_INSTITUCIONAL }) {
  let entradas = Object.entries(datos || {}).sort((a, b) => b[1] - a[1]);
  const total = entradas.reduce((a, [, v]) => a + v, 0);
  let otros = 0;
  if (topN && entradas.length > topN) {
    otros = entradas.slice(topN).reduce((a, [, v]) => a + v, 0);
    entradas = [...entradas.slice(0, topN), ["Otras", otros]];
  }

  if (!entradas.length) {
    return <div className="text-muted py-3" style={{ fontSize: 13 }}>Sin datos</div>;
  }

  const altura = alto || (horizontal ? Math.max(120, entradas.length * 30 + 30) : 220);

  const data = {
    labels: entradas.map((e) => e[0]),
    datasets: [{
      data: entradas.map((e) => e[1]),
      // "Otras" (agrupación del resto) en gris: no es una categoría real.
      backgroundColor: entradas.map((e) => (otros && e[0] === "Otras" ? GRIS_OSCURO : color)),
      hoverBackgroundColor: entradas.map((e) => (otros && e[0] === "Otras" ? GRIS_OSCURO : color)),
      borderRadius: 4,
      borderSkipped: "start",
      barThickness: horizontal ? 14 : undefined,
      maxBarThickness: 34,
    }],
  };

  const tooltip = {
    backgroundColor: "#12283f",
    padding: 10,
    cornerRadius: 8,
    displayColors: false,
    callbacks: {
      label: (ctx) => {
        const v = ctx.parsed[horizontal ? "x" : "y"];
        return ` ${v} persona${v === 1 ? "" : "s"}${total ? ` · ${Math.round((v / total) * 1000) / 10}%` : ""}`;
      },
    },
  };

  const ejeValor = { beginAtZero: true, grid: { color: REJILLA, drawTicks: false }, border: { display: false }, ticks: { precision: 0, font: { size: 10.5 }, padding: 6 } };
  const ejeCat = { grid: { display: false }, border: { display: false }, ticks: { autoSkip: false, font: { size: 11 }, callback: (val, i) => truncar(entradas[i][0], horizontal ? 24 : 14) } };

  const options = {
    indexAxis: horizontal ? "y" : "x",
    responsive: true,
    maintainAspectRatio: false,
    animation: { duration: 400 },
    plugins: { legend: { display: false }, tooltip },
    scales: horizontal ? { x: ejeValor, y: ejeCat } : { y: ejeValor, x: ejeCat },
  };

  return (
    <div style={{ position: "relative", height: altura }}>
      <Bar data={data} options={options} aria-label="Gráfico de barras" role="img" />
    </div>
  );
}
